module.exports = __webpack_public_path__ + "img/stamp-money.bb42f850.png";